<template>
  <div class="auth-experience tw:grid">
    <aside class="auth-story">
      <img
        class="auth-story__photo"
        src="/images/upgrade-bg.jpg"
        :alt="$t('refresh.hero-image')"
        width="1536"
        height="1024"
      >
      <router-link
        to="/"
        class="auth-story__logo"
        aria-label="Indiefy"
      >
        <img
          :src="whiteLogo"
          alt="Indiefy"
          width="120"
          height="32"
        >
      </router-link>
      <div class="auth-story__copy">
        <p class="growth-eyebrow">
          {{ $t('refresh.made-independent') }}
        </p>
        <h2>{{ $t('refresh.auth-story-title') }}<br><span>{{ $t('refresh.auth-story-accent') }}</span></h2>
        <p>{{ $t('refresh.auth-story-description') }}</p>
        <div class="auth-story__chapters">
          <span><GrowthIcon name="music" />{{ $t('refresh.release') }}</span><span><GrowthIcon name="chart" />{{ $t('refresh.understand') }}</span><span><GrowthIcon name="spark" />{{ $t('refresh.grow') }}</span>
        </div>
      </div>
      <div class="auth-story__footer">
        <span>{{ $t('refresh.independent') }}</span><GrowthIcon name="globe" />
      </div>
    </aside>
    <section class="auth-panel">
      <header class="auth-panel__header">
        <router-link
          to="/"
          class="auth-back"
        >
          <GrowthIcon name="arrow" /><span>{{ $t('refresh.back-home') }}</span>
        </router-link>
        <label class="auth-language"><GrowthIcon name="globe" /><select
          :value="locale"
          :aria-label="$t('refresh.language')"
          @change="changeLanguage"
        ><option
          v-for="language in languages"
          :key="language.code"
          :value="language.code"
        >{{ language.name }}</option></select></label>
      </header>
      <router-link
        to="/"
        class="auth-mobile-logo"
        aria-label="Indiefy"
      >
        <img
          :src="darkLogo"
          alt="Indiefy"
          width="105"
          height="28"
        >
      </router-link>
      <div class="auth-panel__form">
        <router-view />
      </div>
      <footer class="auth-panel__footer">
        <span>© {{ new Date().getFullYear() }} Indiefy</span><nav :aria-label="$t('refresh.footer')">
          <router-link to="/terms-and-conditions">
            {{ $t('refresh.terms') }}
          </router-link><router-link to="/privacy-policy">
            {{ $t('refresh.privacy') }}
          </router-link>
        </nav>
      </footer>
    </section>
  </div>
</template>
<script setup>
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { getAvailableLanguages, setLanguage } from '@/i18n';
import GrowthIcon from '@/components/growth/GrowthIcon.vue';
import whiteLogo from '@/assets/images/logo-white.png';
import darkLogo from '@/assets/images/logo-dark.png';
const { locale } = useI18n();
const route = useRoute();
const router = useRouter();
const languages = getAvailableLanguages();
function changeLanguage(event) {
  const language = event.target.value;
  setLanguage(language);
  router.replace({ query: { ...route.query, lang: language } });
}
</script>
